import React, { createContext, useContext, useState, useEffect } from 'react';

const WhatsAppContext = createContext();

export function WhatsAppProvider({ children }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cities, setCities] = useState([
    { name: "Nova União", whatsapp: "5569981274593" },
    { name: "Vale do Paraíso", whatsapp: "5569984333306" }
  ]);

  useEffect(() => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3500);

    fetch("https://cms.webnorte.com.br/api/cities", { signal: controller.signal })
      .then(res => res.json())
      .then(data => {
        clearTimeout(timeoutId);
        if (data && data.data && data.data.length > 0) {
          setCities(data.data.map(c => ({ name: c.name, whatsapp: c.whatsapp })));
        }
      })
      .catch(err => {
        clearTimeout(timeoutId);
        console.error("Erro ao carregar cidades no WhatsAppContext:", err);
      });
  }, []);

  const openWhatsAppModal = () => setIsModalOpen(true);
  const closeWhatsAppModal = () => setIsModalOpen(false);

  return (
    <WhatsAppContext.Provider value={{ isModalOpen, openWhatsAppModal, closeWhatsAppModal, cities }}>
      {children}
    </WhatsAppContext.Provider>
  );
}

export const useWhatsApp = () => useContext(WhatsAppContext);
